module.exports = __webpack_public_path__ + "img/chang_pic.03a4b1cb.png";